<template>
  <b-container fluid class="px-0">
    <b-row>
      <b-col cols="3" class="colProducts">
        <div class="menu-wrapper" :style="menuHeight ? 'height:'+menuHeight+'px' : ''">
          <Product v-on:NewProductAdded="AddNewProductAdded" />
        </div>
      </b-col>
      <b-col cols="9" class="colPlan">
        <div class="menu-bottom-plan">
          <ul>
            <li>
              <button
                @click="AddWindows('#8c8383')"
                class="btn viewBtn btnIcon"
                title="Ajouter une fenêtre"
              >
                <font-awesome-icon icon="border-all" />
              </button>
              <!--<button @click="AddWindows('black')">Ajouter une fenêtre</button>-->
            </li>
            <li>
              <button
                @click="AddWindows('#292929')"
                class="btn viewBtn btnIcon"
                title="Ajouter une portes"
              >
                <font-awesome-icon icon="door-closed" />
              </button>
              <!--<button @click="AddWindows('red')">Ajouter une porte</button>-->
            </li>
            <li>
              <button @click="AddCanvasWall()" class="btn viewBtn btnIcon" title="Ajouter un mur">
                <font-awesome-icon icon="square" />
              </button>
              <!--<button @click="AddCanvasWall()">Ajouter un mur</button>-->
            </li>
            <li>
              <button
                @click="AddCanvasSquare()"
                class="btn viewBtn btnIcon"
                title="Ajouter un meuble"
              >
                <font-awesome-icon icon="archive" />
              </button>
              <!--<button @click="AddCanvasSquare()">Ajouter un meuble</button>-->
            </li>
            <li class="btnRight">
              <button
                @click="SaveSoumissionPlan()"
                class="btn viewBtn btnIcon"
                title="Enregistrer votre plan"
              >
                <font-awesome-icon icon="save" />
              </button>
            </li>
            <li class="btnRight">
              <button
                @click="DeleteSelectWall()"
                class="btn viewBtn btnIcon"
                title="Supprimer l'objet sélectionné"
              >
                <font-awesome-icon icon="trash" />
              </button>
            </li>
            <li class="btnRight">
              <button @click="ResetCanvas()" class="btn viewBtn btnIcon" title="Rétablir le plan">
                <font-awesome-icon icon="undo" />
              </button>
            </li>
            <li class="btnRight">
              <button @click="redoCanvas()" class="btn viewBtn btnIcon" title="Suivant">
                <font-awesome-icon icon="angle-right" />
              </button>
            </li>
            <li class="btnRight">
              <button @click="undoCanvas()" class="btn viewBtn btnIcon" title="Précédent">
                <font-awesome-icon icon="angle-left" />
              </button>
            </li>
            <li class="btnSoumission">
              <div>
                <input
                  type="text"
                  placeholder="Nom de votre plan"
                  class="plan-name"
                  v-model="soumission.plan_title"
                />
                <button
                  v-if="title != soumission.plan_title"
                  @click="SaveSoumissionPlan()"
                  class="btn viewBtn btnIcon"
                >
                  <font-awesome-icon icon="save" />
                </button>
                <router-link
                  :to="{ name: 'ViewSoumission', params: { sid: this.$route.params.sid }}"
                >
                  <button class="btn viewBtn">Demandez une soumission</button>
                </router-link>
              </div>
              <div>
                <div>
                  <small>
                    #{{ soumission.id }} / Dimensions: {{ this.soumission.width }}' X {{ this.soumission.height }}'
                    <div v-if="active_product" class="text-describe">
                      <div id="describe">
                        &nbsp;&nbsp;/&nbsp;&nbsp;{{product.name}}
                        <span v-if="product.images"> / </span>
                        <img
                          v-if="product.images"
                          :src="GetImage(product.images)"
                          height="15px"
                        />
                      </div>
                      <b-tooltip target="describe" placement="bottom">
                        <div v-html="product.describe"></div>
                      </b-tooltip>
                    </div>
                  </small>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="clear:both"></div>
        <div class="plan-wrapper">
          <div class="saving">{{ saving }}</div>
          <canvas id="floorplan" width="600" height="600"></canvas>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Product from "./Product";

export default {
  name: "Plan",
  components: {
    Product
  },
  data() {
    return {
      canvas: null,
      last_created_vertical: 10,
      title: "",
      menuHeight: null,
      soumission: {},
      active_product: false,
      product: {},
      saving: "Enregistement automatique au 5 secondes",
      canvas_modified: false,
      interval: "",
      iLef: 0,
      iTop: 0,
      oLef: 0,
      oTop: 0,
      history: [],
      mods: 0
    };
  },
  mounted() {
    this.LoadCanvasFromJSON();
    this.SavingCanvas();
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  },
  methods: {
    LoadCanvasFromJSON: function() {
      var self = this
      if (localStorage.getItem("token")) {
        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };
      } else {
        var dheader = { "Content-Type": "application/json" };
      }
      this.$http
        .get(this.$url_name + "/submission/" + this.$route.params.sid + "/", {
          headers: dheader
        })
        .then(response => {
          if (response.body) {
            this.soumission = response.body;
            if (this.soumission.plan) {
              this.canvas = new fabric.Canvas("floorplan", {
                selection: false
              });
              var c_width =
                this.soumission.width * (600 / this.soumission.width) + 20;
              var c_height =
                this.soumission.height * (600 / this.soumission.width) + 20;
              this.canvas.setDimensions({ width: c_width, height: c_height });
              this.canvas.loadFromJSON(response.body.plan);
              this.canvas.renderAll();
              this.historyCanvas(true);
              this.historyCanvas(true);
              /* ---------- */
              this.canvas.on("object:selected", this.ObjectSelected);
              this.canvas.on("selection:updated", this.ObjectSelected);
              this.canvas.on("object:added", this.CanvasModified);
              this.canvas.on("object:removed", this.ObjectRemoved);
              this.canvas.on("object:modified", this.CanvasModified);
              this.canvas.on("object:moving", this.ObjectMoving);
              this.canvas.on("mouse:down", function(k) {
                self.historyCanvas(true);
              });
              this.canvas.on("mouse:up", function(k) {
                self.historyCanvas(true);
              });
              setTimeout(() => {
                this.canvas.forEachObject(obj => {
                  if(obj.type == 'line' || obj.type == 'text') {
                    obj.set('selectable', false)
                    obj.set('evented', false)
                  };
                })
              }, 200);
            } else {
              this.CreateCanvas();
            }
          }
        })
        .catch(err => {
          console.log("erreur loadjson:");
          console.log(err);
        });
      let colplan = this.$el.querySelector(".colPlan");
      this.menuHeight = colplan.clientHeight;
    },
    CreateCanvas: function() {
      var self = this;
      // Dessiner une ligne avec la souris

      // - Draw grid --
      this.canvas = new fabric.Canvas("floorplan", { selection: false });

      var c_width = this.soumission.width * (600 / this.soumission.width) + 20;
      var c_height =
        this.soumission.height * (600 / this.soumission.width) + 20;

      this.canvas.setDimensions({ width: c_width, height: c_height });

      this.canvas.backgroundColor = "#e5f4fc";

      // events

      /* ---------- */
      this.canvas.on("object:selected", function(o) {
        var activeObj = o.target;
        if (activeObj.get("type") === "rect") {
          activeObj.set({ borderColor: "blue", cornerColor: "orange" });
        }
      });

      this.canvas.on("object:added", this.CanvasModified);
      //this.canvas.on("object:removed", this.CanvasModified);
      this.canvas.on("object:removed", this.ObjectRemoved);
      this.canvas.on("selection:updated", this.ObjectSelected);
      this.canvas.on("object:selected", this.ObjectSelected);
      this.canvas.on("object:modified", this.CanvasModified);
      this.canvas.on("object:moving", this.ObjectMoving);
      //this.canvas.on("mouse:wheel", this.ObjectMouse);

      /*var gridsize = 40;
      var cellWidth = 40;*/

      var gridsize = 620 / this.soumission.width;
      var cellWidth = 620 / this.soumission.width;

      for (var x = 1; x < this.canvas.width / gridsize; x++) {
        var newLine = new fabric.Line([cellWidth * x, 0, cellWidth * x, 620], {
          stroke: "#cccccc",
          strokeWidth: 1,
          selectable: false,
            evented: false
        });

        this.canvas.add(newLine);

        var newLine2 = new fabric.Line([0, cellWidth * x, 620, cellWidth * x], {
          stroke: "#cccccc",
          strokeWidth: 1,
          selectable: false,
            evented: false
        });

        this.canvas.add(newLine2);
      }

      /* Show numbers in grid */

      for (var i = 1; i < c_width / gridsize; i++) {
        // Horizontal

        this.canvas.add(
          new fabric.Text(String(i * 1) + "'", {
            left: cellWidth + (i - 1) * gridsize,
            top: 25,
            fontSize: 14,
            selectable: false,
            evented: false
          })
        );

        // Vertical
        this.canvas.add(
          new fabric.Text(String(i * 1) + "'", {
            left: 25,
            top: cellWidth + (i - 1) * gridsize,
            fontSize: 14,
            textAlign: "right",
            selectable: false,
            evented: false
          })
        );
      }

      this.canvas.on("mouse:down", function(k) {
        self.historyCanvas(true);
      });
      this.canvas.on("mouse:up", function(k) {
        self.historyCanvas(true);
      });
      this.canvas.renderAll();
      this.historyCanvas(true);
    },
    ShowActiveProduct(product_id) {
      this.product = {}
      this.product = {name: product_id};
      this.active_product = true;
      /*
      this.$http.get(this.$host_name + "/produits/detail/" + product_id + "/", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        // result
        this.active_product = true;
        this.product = response.body;
      })
      .catch(err => {
        console.log(err.status);
      });
      */
    },
    CloseProduct: function() {
      this.active_product = false;
    },
    GetImage: function(images) {
      if (images) {
        return images[0].thumbnail;
      }
    },
    CategorieList: function(id) {
      this.productsList = [];
    },
    DeleteSelectWall() {
      this.canvas.remove(this.canvas.getActiveObject());
    },
    AddNewProductAdded: function(product_id, s_produit_id) {
      var self = this;

      if (localStorage.getItem("token")) {
        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };
      } else {
        var dheader = { "Content-Type": "application/json" };
      }

      this.$http
        .get(this.$url_name + "/product/" + product_id + "/", {
          headers: dheader
        })
        .then(response => {
          var product = response.body;
          var svgicon = product.svg_icon.replace(
            "plomberie-paradis-stage.us.aldryn.io",
            "http://localhost:8000"
          );
          var object_image = svgicon; //require("../assets/mobilier.svg"); //product.svg_icon; //
          var main_canvas = self.canvas;
          var echelle = 620 / self.soumission.width / 12;
          if (product.sens_icon == "vertical") {
            var icon_width = echelle * product.height_in_inch;
            var icon_height = echelle * product.width_in_inch;
          } else {
            var icon_width = echelle * product.width_in_inch;
            var icon_height = echelle * product.height_in_inch;
          }

          if (icon_width <= 0) {
            icon_width = 100;
          }

          if (icon_height <= 0) {
            icon_height = 100;
          }

          //resize image

          this.$http
            .get(this.$host_name +
              "/produits/resize_image/" +
                product.id +
                "/" +
                Math.round(icon_width) +
                "/" +
                Math.round(icon_height) +
                "/",
              {
                headers: dheader
              }
            )
            .then(response => {
              var image_resized = response.body.thumbnail;
              fabric.util.loadImage(image_resized, function(img) {
                var object = new fabric.Image(img);
                object.set({
                  pkid: s_produit_id,
                  id: product.slug,
                  left: 0,
                  top: 0,
                  width: Math.round(icon_width),
                  height: Math.round(icon_height)
                });
                object.set('obj_type','produit')
                object.setControlsVisibility({
                  bl: false,
                  br: false,
                  mt: false,
                  mb: false,
                  ml: false,
                  mr: false,
                  tl: false,
                  tr: false
                });
                main_canvas.add(object);

              }, null, {
                crossOrigin: 'anonymous'
              })
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err.response);
        });

      this.historyCanvas(true);
    },
    AddWindows: function(color) {
      var main_canvas = this.canvas;

      var windows = new fabric.Rect({
        width: 20,
        height: 100,
        left: this.iLef,
        top: this.iTop,
        fill: color,
        stroke: "grey",
        strokeWidth: 1
      });

      if (this.iLef > this.canvas.width - 100) {
        this.iLef = 0;
      } else {
        this.iLef += 10;
      }
      if (this.iTop > this.canvas.height - 100) {
        this.iTop = 0;
      } else {
        this.iTop += 10;
      }

      windows.set("obj_type", "windows_door");

      var center_coords = windows.getCenterPoint();

      windows.hasBorders = true;
      windows.cornerStyle = "circle";
      windows.cornerSize = 20;
      windows.cornerColor = "grey";

      windows.setControlsVisibility({
        bl: false, //bottom left
        br: false, //bottom right
        mt: true, // middle top disable
        mb: true, // midle bottom
        ml: true, // middle left
        mr: true, // I think you get it
        tl: false, //top left
        tr: false
      });

      main_canvas.add(windows);

      main_canvas.renderAll();
      this.historyCanvas(true);
    },
    AddCanvasWall: function() {
      var main_canvas = this.canvas;

      var rectangle = new fabric.Rect({
        width: 20,
        height: main_canvas.height - 40,
        left: this.last_created_vertical,
        top: 20,
        //angle: -30,
        fill: "white",
        stroke: "grey",
        strokeWidth: 1,
        horizon_vertial: "vertical"
      });

      var center_coords = rectangle.getCenterPoint();

      rectangle.hasBorders = true;
      rectangle.cornerStyle = "circle";
      rectangle.cornerSize = 20;
      rectangle.cornerColor = "grey";

      rectangle.setControlsVisibility({
        bl: false, //bottom left
        br: false, //bottom right
        mt: true, // middle top disable
        mb: true, // midle bottom
        ml: true, // middle left
        mr: true, // I think you get it
        tl: false, //top left
        tr: false
      });

      rectangle.set("obj_type", "wall");

      var url = require("../assets/crossline-lines.png");

      fabric.util.loadImage(url, function(img) {
        rectangle.set(
          "fill",
          new fabric.Pattern({
            source: img,
            repeat: "repeat"
          })
        );

        main_canvas.renderAll();
      });

      this.last_created_vertical = this.last_created_vertical + 15;

      main_canvas.add(rectangle);

      main_canvas.renderAll();
      this.historyCanvas(true);
    },
    AddCanvasSquare: function() {
      var main_canvas = this.canvas;

      var k = new fabric.Rect({
        width: 50,
        height: 50,
        left: this.last_created_vertical,
        top: 20,
        fill: "#eee",
        stroke: "grey",
        strokeWidth: 1,
        horizon_vertial: "vertical"
      });

      var center_coords = k.getCenterPoint();

      k.hasBorders = true;
      k.cornerStyle = "circle";
      k.cornerSize = 20;
      k.cornerColor = "grey";

      k.setControlsVisibility({
        bl: true,
        br: true,
        mt: true,
        mb: true,
        ml: true,
        mr: true,
        tl: true,
        tr: true
      });

      k.set("obj_type", "wall");

      this.last_created_vertical = this.last_created_vertical + 15;

      main_canvas.add(k);

      main_canvas.renderAll();
      this.historyCanvas(true);
    },
    undoCanvas: function() {
      if (this.mods < this.history.length) {
        this.canvas.clear().renderAll();
        this.canvas.loadFromJSON(
          this.history[this.history.length - 1 - this.mods - 1]
        );
        this.canvas.renderAll();
        this.mods += 1;
        setTimeout(() => {
          this.canvas.forEachObject(obj => {
            if(obj.type == 'line' || obj.type == 'text') {
              obj.set('selectable', false)
              obj.set('evented', false)
            };
          })
        }, 100);
      }
    },
    redoCanvas: function() {
      if (this.mods > 0) {
        this.canvas.clear().renderAll();
        this.canvas.loadFromJSON(
          this.history[this.history.length - 1 - this.mods + 1]
        );
        this.mods -= 1;
        setTimeout(() => {
          this.canvas.forEachObject(obj => {
            if(obj.type == 'line' || obj.type == 'text') {
              obj.set('selectable', false)
              obj.set('evented', false)
            };
          })
        }, 100);
      }
    },
    historyCanvas: function(k) {
      if (k === true) {
        var j = this.canvas.toJSON([
          "_controlsVisibility",
          "lockRotation",
          "lockMovementX",
          "lockMovementY",
          "lockScalingX",
          "lockScalingY",
          "lockUniScaling",
          "selectable",
          "lockType",
          "lock",
          "id",
          "sid",
          "obj_type"
        ]);
        this.history.push(j);
      }
    },
    SaveSoumissionPlan: function() {
      this.saving = "Enregistrement en cours";
      this.title = this.soumission.plan_title;

      var image_encode = this.canvas.toDataURL("png");

      var data = {
        image_encoded: this.canvas.toDataURL("png"),
        plan_title: this.soumission.plan_title,
        plan: this.canvas.toJSON([
          "_controlsVisibility",
          "lockRotation",
          "lockMovementX",
          "lockMovementY",
          "lockScalingX",
          "lockScalingY",
          "lockUniScaling",
          "selectable",
          "lockType",
          "lock",
          "id",
          "sid",
          "obj_type"
        ])
      };

      if (this.canvas) {
        if (localStorage.getItem("token")) {
          var dheader = {
            "Content-Type": "application/json",
            Authorization: "Token " + localStorage.getItem("token")
          };
        } else {
          var dheader = { "Content-Type": "application/json" };
        }

        this.$http
          .put(
            this.$url_name + "/submission/" + this.$route.params.sid + "/",
            data,
            {
              headers: dheader
            }
          )
          .then(response => {
            this.soumission = response.body;
            this.saving = "";
            this.canvas_modified = false;
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        console.log("no canvas found");
      }
    },
    ResetCanvas: function() {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous vraiment supprimer tous les produits ?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
        .then(value => {
          if (value) {
              this.doResetCanvas()
          }
        })
    },
    doResetCanvas: function() {
      if (this.canvas) {
        this.canvas.forEachObject(obj => {
          if(obj.type !== 'line' && obj.type !== 'text') {
            this.canvas.remove(obj)
          }
        })
        if (localStorage.getItem("token")) {
          var dheader = {
            "Content-Type": "application/json",
            Authorization: "Token " + localStorage.getItem("token")
          };
        } else {
          var dheader = { "Content-Type": "application/json" };
        }
        // ===---
        this.$http.delete(this.$url_name + "/submission/" + this.$route.params.sid + "/delete_all/", { headers: dheader }
          )
          .then(() => {
            this.CanvasModified()
            this.SavingCanvas()
          })
          .catch(() => {
            this.$toasted.show("Une erreur est survenue.", {
              duration: 2000,
              type: "error"
            });
          });
        // ===---
      };
    },
    findNewPos(distX, distY, target, obj) {
      // See whether to focus on X or Y axis
      if (Math.abs(distX) > Math.abs(distY)) {
        if (distX > 0) {
          target.setLeft(obj.getLeft() - target.getWidth());
        } else {
          target.setLeft(obj.getLeft() + obj.getWidth());
        }
      } else {
        if (distY > 0) {
          target.setTop(obj.getTop() - target.getHeight());
        } else {
          target.setTop(obj.getTop() + obj.getHeight());
        }
      }
    },
    ObjectMoving: function(options) {
      var main_canvas = this.canvas;

      var pointer = main_canvas.getPointer(options.e);
      var object = options.target;

      if (options.target.obj_type == "windows_door") {
        var windows = object;
        //si la souris est en haut
        if (pointer.y < 20) {
          options.target.set({
            //left: 0,
            top: 0,
            width: 100,
            height: 20,
            lockRotation: true
            //top: Math.round(options.target.top / grid) * grid
          });
          windows.setControlsVisibility({
            bl: false, //bottom left
            br: false, //bottom right
            mt: true, // middle top disable
            mb: true, // midle bottom
            ml: true, // middle left
            mr: true, // I think you get it
            tl: false, //top left
            tr: false
          });
        }

        //si la souris est a gauche

        if (pointer.x < 20) {
          options.target.set({
            left: 0,
            //top: 0,
            width: 20,
            height: 100,
            lockRotation: true
            //top: Math.round(options.target.top / grid) * grid
          });

          windows.setControlsVisibility({
            bl: false, //bottom left
            br: false, //bottom right
            mt: true, // middle top disable
            mb: true, // midle bottom
            ml: true, // middle left
            mr: true, // I think you get it
            tl: false, //top left
            tr: false
          });
        }

        //si la souris est a droite

        if (pointer.x > main_canvas.width - 20) {
          options.target.set({
            left: main_canvas.width - 20,
            width: 20,
            height: 100,
            lockRotation: true
          });

          windows.setControlsVisibility({
            bl: false, //bottom left
            br: false, //bottom right
            mt: true, // middle top disable
            mb: true, // midle bottom
            ml: false, // middle left
            mr: false, // I think you get it
            tl: false, //top left
            tr: false
          });
        }

        //si la souris est en bas

        if (pointer.y > main_canvas.height - 20) {
          options.target.set({
            //left: main_canvas.width - 20,
            top: main_canvas.height - 20,
            width: 100,
            height: 20,
            lockRotation: true
          });

          windows.setControlsVisibility({
            bl: false, //bottom left
            br: false, //bottom right
            mt: true, // middle top disable
            mb: true, // midle bottom
            ml: true, // middle left
            mr: true, // I think you get it
            tl: false, //top left
            tr: false
          });
        }

        main_canvas.renderAll();
      } else {
        this.overlapCheck(options);
      }
    },
    overlapCheck(options) {
      let snap = 20;
      options.target.setCoords();
      // ===--- don't go outside canvas
      if (options.target.getBoundingRect().left < snap) {
        options.target.left =
          options.target.left - options.target.getBoundingRect().left;
      }
      if (options.target.getBoundingRect().top < snap) {
        options.target.top =
          options.target.top - options.target.getBoundingRect().top;
      }
      if (
        options.target.getBoundingRect().width +
          options.target.getBoundingRect().left >
        this.canvas.width - snap
      ) {
        options.target.left =
          this.canvas.width -
          options.target.getBoundingRect().width +
          (options.target.left - options.target.getBoundingRect().left);
      }
      if (
        options.target.getBoundingRect().height +
          options.target.getBoundingRect().top >
        this.canvas.height - snap
      ) {
        options.target.top =
          this.canvas.height -
          options.target.getBoundingRect().height +
          (options.target.top - options.target.getBoundingRect().top);
      }
      // ===---
      options.target.canvas.forEachObject(obj => {
        if (obj.obj_type === "produit" || obj.type === "image") {
          if (this.canvas.getActiveObject().obj_type === "produit" || this.canvas.getActiveObject().obj_type === "image") {
            this.canvas.getActiveObject().set('backgroundColor','')
            this.canvas.getActiveObject().set('opacity','1')
          } else {
            this.canvas.getActiveObject().setShadow();
          }
        }
      });
      options.target.canvas.forEachObject(obj => {
        if (obj === options.target) {
          return;
        } else {
          if (obj.obj_type === "produit" || obj.type === "image" || obj.obj_type === "wall") {
            if (
              options.target.isContainedWithinObject(obj) ||
              options.target.intersectsWithObject(obj) ||
              obj.isContainedWithinObject(options.target)
            ) {
              if (obj.obj_type === "produit" || obj.type === "image") {
                obj.set('backgroundColor','#ff0000')
                obj.set('opacity','0.8')
              } else {
                obj.setShadow({
                  color: "#ff0000",
                  blur: 10,
                  offsetX: 0,
                  offsetY: 0
                });
              }
              if (this.canvas.getActiveObject().obj_type === "produit" || this.canvas.getActiveObject().type === "image") {
                this.canvas.getActiveObject().set('backgroundColor','#ff0000')
                this.canvas.getActiveObject().set('opacity','0.8')
              } else {
                this.canvas.getActiveObject().setShadow({
                  color: "#ff0000",
                  blur: 10,
                  offsetX: 0,
                  offsetY: 0
                });
              }
            } else {
              var autreCollision = false;
              obj.canvas.forEachObject(autre => {
                if (autre === obj) {
                  return;
                } else if (autre.obj_type === "produit" || autre.type === "image" || autre.obj_type === "wall") {
                  if (
                    obj.isContainedWithinObject(autre) ||
                    obj.intersectsWithObject(autre) ||
                    autre.isContainedWithinObject(obj)
                  ) {
                    autreCollision = true;
                  }
                }
              });
              if (autreCollision === true) {
                if (obj.obj_type === "produit" || obj.type === "image") {
                  obj.set('backgroundColor','#ff0000')
                  obj.set('opacity','0.8')
                } else {
                  obj.setShadow({
                    color: "#ff0000",
                    blur: 10,
                    offsetX: 0,
                    offsetY: 0
                  });
                }
              } else {
                if (obj.obj_type === "produit" || obj.type === "image") {
                  obj.set('backgroundColor','')
                  obj.set('opacity','1')
                } else {
                  obj.setShadow();
                }
              }
            }
          }
        }
      });
      options.target.setCoords();
      // ===---
    },
    findNewPos(distX, distY, target, obj) {
      if (Math.abs(distX) > Math.abs(distY)) {
        if (distX > 0) {
          target.left = obj.left - target.width * target.scaleX;
        } else {
          target.left = obj.left + obj.width * obj.scaleX;
        }
      } else {
        if (distY > 0) {
          target.top = obj.top - target.height * target.scaleY;
        } else {
          target.top = obj.top + obj.height * obj.scaleY;
        }
      }
    },
    CanvasModified: function() {
      this.canvas_modified = true;
    },
    ObjectSelected: function(e) {
      if (e.target.type !== 'text' && e.target.type !== 'line') {
        if (e.target.id) {
          this.ShowActiveProduct(e.target.id);
        } else {
          this.product = null;
          this.active_product = false;
        }
        var activeObj = e.target;
        if (activeObj.get("type") === "rect") {
          activeObj.set({ borderColor: "blue", cornerColor: "orange" });
        }
      }
    },
    ObjectMouse: function(opt) {
      var delta = opt.e.deltaY;
      var zoom = this.canvas.getZoom();
      zoom = zoom + delta / 200;
      if (zoom > 20) zoom = 20;
      if (zoom < 0.01) zoom = 0.01;
      this.canvas.setZoom(zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    },
    ObjectRemoved: function(e) {
      this.canvas_modified = true;

      var object = e.target;

      if (object.pkid) {
        var data = { id: object.pkid };

        if (localStorage.getItem("token")) {
          var dheader = {
            "Content-Type": "application/json",
            Authorization: "Token " + localStorage.getItem("token")
          };
        } else {
          var dheader = { "Content-Type": "application/json" };
        }

        this.$http
          .post(
            this.$url_name +
              "/submission/" +
              this.$route.params.sid +
              "/delete_product/",
            data,
            {
              headers: dheader
            }
          )
          .then(() => {
            this.$toasted.show("Produit supprimé avec succès", {
              duration: 2000,
              type: "success"
            });
          })
          .catch(() => {
            this.$toasted.show("Une erreur est survenue.", {
              duration: 2000,
              type: "error"
            });
          });
      }
    },
    SavingCanvas() {
      const self = this;
      this.interval = setInterval(function() {
        if (self.canvas_modified) {
          self.SaveSoumissionPlan();
        }
      }, 5000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.plan-name {
  margin-left: 0;
  width: 200px;
}
.btnSoumission > div > a {
  float: right;
}
.btnSoumission > div .btnIcon {
  font-size: 20px;
  padding: 0 0 0 5px;
}
.saving {
  color: #888;
  font-size: 0.8rem;
  line-height: 110%;
  height: 25px;
}
.menu-wrapper {
  background-color: #fff;
  height: 730px;
  overflow: auto;
  text-align: center;
  padding-top: 25px;
}
.menu-plan {
  list-style-type: none;
  display: block;
}
.menu-plan li {
  margin-bottom: 15px;
  border: 1px solid #fff;
  height: 160px;
  margin-top: 15px;
  padding: 40px;
}
.plan-wrapper {
  background-color: #fff;
  padding: 10px;
  padding-bottom: 40px;
  height: auto;
}

.menu-bottom-plan ul {
  list-style-type: none;
  display: block;
  margin: 0;
  padding: 0;
}
.menu-bottom-plan ul li {
  float: left;
  margin: 5px 5px 15px;
}
.btnIcon {
  border: none;
  font-size: 33px;
  line-height: auto;
  font-weight: 400;
  width: auto;
  height: auto;
  padding: 10px 20px;
  margin: 0;
}
.menu-bottom-plan ul li.btnRight {
  float: right;
}
.menu-bottom-plan ul li.btnSoumission {
  clear: both;
  float: none;
  display: block;
  width: 100%;
  margin: 5px;
}
.text-describe,
#describe {
  display: inline;
}
.text-describe:hover {
  cursor: help;
}
.tooltip {
  background-color: #44f;
}
.col-3.colProducts {
  border-right: 1px solid #eee;
  border-bottom: none;
  padding-left: 0;
  padding-right: 0;
}
.col-3.colProducts .menu-wrapper {
  height: calc(100vh - 70px);
}
@media (max-width: 1199px) {
  .col-3.colProducts,
  .col-9.colPlan {
    display: block;
    width: 100%;
    max-width: 100%;
    -ms-flex: 0 1 auto;
    -webkit-box-flex: 0 1 auto;
    flex: 0 1 auto;
  }
  .col-3.colProducts {
    border-right: none;
    border-bottom: 1px solid #eee;
  }
  .col-3.colProducts .menu-wrapper {
    height: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Plan.vue